import { Chart } from 'chart.js';
import JQueryView from '../../../common/views/jqueryView';

export default class TypeRatio extends JQueryView {
  buyAmount: number;
  sellAmount: number;

  constructor(buyAmount: number, sellAmount: number) {
    super('#type_ratio_chart_view');
    this.buyAmount = buyAmount;
    this.sellAmount = sellAmount;
    this.renderPc();
    this.renderSp();
  }

  checkedNumberExist() {
    if (this.buyAmount > 0 || this.sellAmount > 0) {
      return true;
    } else {
      return false;
    }
  }

  returnCheckedNumber() {
    if (this.checkedNumberExist()) {
      return [this.buyAmount, this.sellAmount];
    } else {
      return [-1, -1];
    }
  }

  renderPc() {
    const element = document.getElementById(
      'type_ratio_chart_pc',
    ) as HTMLCanvasElement;
    const context = element.getContext('2d');

    if (context == null) {
      return;
    }

    new Chart(context, {
      type: 'doughnut',
      data: {
        labels: ['買い注文株数', '売り注文株数'],
        datasets: [
          {
            data: this.returnCheckedNumber(),
            backgroundColor: ['#008895', '#DFE3E8'],
            hoverBackgroundColor: ['#008895', '#DFE3E8'],
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            enabled: this.checkedNumberExist(),
          },
        },
      },
    });
  }

  renderSp() {
    const element = document.getElementById(
      'type_ratio_chart_sp',
    ) as HTMLCanvasElement;
    const context = element.getContext('2d');

    if (context == null) {
      return;
    }

    new Chart(context, {
      type: 'doughnut',
      data: {
        labels: ['買い注文株数', '売り注文株数'],
        datasets: [
          {
            data: this.returnCheckedNumber(),
            backgroundColor: ['#008895', '#DFE3E8'],
            hoverBackgroundColor: ['#008895', '#DFE3E8'],
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            enabled: this.checkedNumberExist(),
          },
        },
      },
    });
  }
}
